import $ from 'jquery'
import throttle from 'lodash/throttle'

declare let gtag: Function

import slick from 'slick-carousel/slick/slick'

console.log(slick)

import '@fortawesome/fontawesome-free/css/all.css'
import 'bulma/css/bulma.css'
import 'slick-carousel/slick/slick.css'

import './app.css'

const resizeVideo = () => {
  $('.video').css('height', `${$('.video').width() / 1.8}px`)
}

const lazyLoadImage = () => {
  $.each($('.lazy-load-picture'), (i, image) => {
    if (
      $(window).scrollTop() >
        ($(image).offset().top - $(window).height() - $(window).height()) / 2 &&
      $(image).data('srcset') !== $(image).attr('srcset')
    ) {
      $(image).attr('srcset', $(image).data('srcset'))
      if (
        parseInt($(image).attr('width'), 10) < $('.container').width() &&
        $(image).data('image-type') === 'article' &&
        $(image).hasClass('image-gif')
      ) {
        $(image)
          .css('width', $(image).attr('width'))
          .css('height', $(image).attr('height'))
          .css('margin', '0 auto')
      }
    }
  })
}

const initDots = (event: any, sl: any, currentSlide: number) => {
  const i = typeof currentSlide === 'undefined' ? 0 : currentSlide
  if (sl.$dots) {
    sl.$dots.html(i + 1 + '/' + sl.slideCount)
  }
}

const initCarousel = () => {
  $('#carousel-hero').on('init afterChange', initDots)

  $('#carousel-blog').on('click', '.item > a', (e) => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-blog',
      eventLabel:
        $(e.target).closest('a').data('index') + '-' + $(e.target).closest('a').data('title'),
      hitType: 'event',
    })
  })

  $('#carousel-hero').on('click', '.item > a', (e) => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-hero',
      eventLabel:
        $(e.target).closest('a').data('index') + '-' + $(e.target).closest('a').data('title'),
      hitType: 'event',
    })
  })

  $('#carousel-social').on('click', '.item', (e) => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-social',
      eventLabel: $(e.target).closest('.item').data('index'),
      hitType: 'event',
    })
  })

  $('#carousel-blog').on('click', '.arrow-left', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-blog',
      eventLabel: 'left',
      hitType: 'event',
    })
  })

  $('#carousel-blog').on('click', '.arrow-right', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-blog',
      eventLabel: 'right',
      hitType: 'event',
    })
  })

  $('#carousel-social').on('click', '.arrow-left', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-social',
      eventLabel: 'left',
      hitType: 'event',
    })
  })

  $('#carousel-social').on('click', '.arrow-right', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-social',
      eventLabel: 'right',
      hitType: 'event',
    })
  })

  $('#carousel-hero').on('click', '.arrow-left', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-hero',
      eventLabel: 'left',
      hitType: 'event',
    })
  })

  $('#carousel-hero').on('click', '.arrow-right', () => {
    gtag('send', {
      eventAction: 'click',
      eventCategory: 'carousel-hero',
      eventLabel: 'right',
      hitType: 'event',
    })
  })

  $('#carousel-hero').on('swipe', (event: any, sl: any, direction: string) => {
    gtag('send', {
      eventAction: 'swipe',
      eventCategory: 'carousel-hero',
      eventLabel: direction,
      hitType: 'event',
    })
  })

  $('#carousel-social').on('swipe', (event: any, sl: any, direction: string) => {
    gtag('send', {
      eventAction: 'swipe',
      eventCategory: 'carousel-blog',
      eventLabel: direction,
      hitType: 'event',
    })
  })

  $('#carousel-blog').on('swipe', (event: any, sl: any, direction: string) => {
    gtag('send', {
      eventAction: 'swipe',
      eventCategory: 'carousel-social',
      eventLabel: direction,
      hitType: 'event',
    })
  })

  // @ts-ignore
  $('#carousel-hero').slick({
    autoplay: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  })

  $('#carousel-blog').on('init afterChange', initDots)

  // @ts-ignore
  $('#carousel-blog').slick({
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          dots: true,
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 426,
        settings: {
          arrows: false,
          dots: true,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 3,
  })

  $('#carousel-social').on('init afterChange', initDots)

  // @ts-ignore
  $('#carousel-social').slick({
    infinite: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          dots: true,
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 426,
        settings: {
          arrows: false,
          dots: true,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 3,
  })
}

$(() => {
  lazyLoadImage()
  resizeVideo()
  initCarousel()

  $('#search-form').submit((e) => {
    if ($('#search-input').val()) {
      document.location.href = '/search/' + $('#search-input').val()
    }
    e.preventDefault()
  })

  $('.navbar-burger').click(() => {
    $('.navbar-burger').toggleClass('is-active')
    $('.navbar-menu').toggleClass('is-active')
    $('body').toggleClass('nav-bar-is-active')
    $('.navbar-item.has-dropdown').toggleClass('is-active')
  })

  $('.slick-prev').html('<i class="arrow-left fa-2x"></i>')
  $('.slick-next').html('<i class="arrow-right fa-2x"></i>')

  $(window).on('scroll', throttle(lazyLoadImage.bind(this), 250))
  $(window).on('resize', throttle(resizeVideo.bind(this), 500))
})
